import PropTypes from 'prop-types';
import cx from 'classnames';

import './ModalButton.scss';

/**
 * The button a modal commits or backs out with.
 *
 * Seven modals had hand-copied the same `.btn` / `.btn.primary` / `.btn.secondary` block into
 * their own SCSS — character for character in most of them, drifting by a padding step or a
 * disabled opacity in the rest. This is that block, once. `.btn` itself is left to the several
 * unrelated things in the app that already answer to it; a modal button has its own name now, so
 * the two can't collide.
 *
 * `block` is the stacked form: a button that owns its line rather than sharing it with a Cancel.
 * The play buttons in the two MIDI modals and every row of PartOptionsModal are this.
 */
const ModalButton = ({ variant = 'primary', block = false, className, children, ...rest }) => (
  <button type="button" className={cx('ModalButton', variant, { block }, className)} {...rest}>
    {children}
  </button>
);

ModalButton.propTypes = {
  variant: PropTypes.oneOf(['primary', 'secondary', 'danger']),
  /** Fills its line, and takes the roomier padding that suits a button standing alone */
  block: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
};

export default ModalButton;
